export const createComboUnitId = function (playerIds: string[]): string {
    return playerIds.sort().join('-');
};
